import React from 'react';
import { CAT, Avatar, Progress, fmtTime } from './ShareResults';
import './GameResults.css';

// Results view shared by races and the daily challenge.
//   stats:   [{ value, suffix?, label, tone? ('up' | 'down') }]  four cells
//   table:   { title, kind: 'race' | 'daily', rows }
//            race rows:  { key, rank, name, color, isYou, foundLevels, time, lives }
//            daily rows: { key, rank, name, color, isYou, time, solved, found }
//   history: [[level, level, level, level], ...]  one row per guess
//   missed:  [{ level, name, words }]
const GameResults = ({ label, title, stats, table, history, missed, onCopy, actions }) => (
  <div className="cr-page">
    <div className="results-top">
      <div className="cr-label">{label}</div>
      <h1 className="cr-title">{title}</h1>
    </div>

    <section className="cr-card results-stats" aria-label="Your result">
      {stats.map((s) => (
        <div className="cr-stat results-stat" key={s.label}>
          <b className={s.tone ? `results-${s.tone}` : undefined}>
            {s.value}
            {s.suffix && <span className="results-suffix">{s.suffix}</span>}
          </b>
          <span>{s.label}</span>
        </div>
      ))}
    </section>

    <section className={`cr-card results-table results-${table.kind}`}>
      <div className="cr-row-head cr-card-pad results-table-head">
        <h2 className="cr-section-title">{table.title}</h2>
      </div>
      <div role="table" aria-label={table.title}>
        {table.kind === 'race' ? (
          <div className="cr-tr cr-th" role="row">
            <span role="columnheader">Rank</span>
            <span role="columnheader">Player</span>
            <span role="columnheader">Found</span>
            <span role="columnheader" className="cr-r">Time</span>
            <span role="columnheader" className="cr-r">Lives</span>
          </div>
        ) : (
          <div className="cr-tr cr-th" role="row">
            <span role="columnheader">Rank</span>
            <span role="columnheader">Player</span>
            <span role="columnheader" className="cr-r">Time</span>
          </div>
        )}
        {table.rows.length === 0 && (
          <div className="cr-tr" role="row"><span className="cr-faint results-empty">No results yet</span></div>
        )}
        {table.rows.map((r) => (
          <div key={r.key} role="row" className={`cr-tr${r.isYou ? ' cr-me' : ''}${r.gap ? ' results-gap' : ''}`}>
            <span role="cell" className="cr-tnum results-rank">{r.rank}</span>
            <span role="cell" className="cr-player">
              <Avatar name={r.name} color={r.color} />
              <b>{r.isYou ? 'You' : r.name}</b>
            </span>
            {table.kind === 'race' ? (
              <>
                <span role="cell"><Progress levels={r.foundLevels} /></span>
                <span role="cell" className="cr-r cr-tnum">{r.time != null ? fmtTime(r.time) : '-'}</span>
                <span role="cell" className="cr-r cr-tnum">{r.lives}</span>
              </>
            ) : (
              <span role="cell" className="cr-r cr-tnum">
                {r.solved ? fmtTime(r.time) : <span className="cr-faint">{r.found}/4 found</span>}
              </span>
            )}
          </div>
        ))}
      </div>
    </section>

    <div className="results-grid">
      <section className="cr-card cr-card-pad results-box">
        <div className="cr-row-head">
          <h2 className="cr-section-title">Submission History</h2>
          <button type="button" className="cr-btn sm" onClick={onCopy}>Copy Results</button>
        </div>
        {history.length ? (
          <div className="results-history" role="img" aria-label={`${history.length} guesses`}>
            {history.map((row, i) => (
              <div className="results-history-row" key={i}>
                {row.map((lvl, j) => <i key={j} style={lvl != null ? { background: CAT[lvl] } : undefined} />)}
              </div>
            ))}
          </div>
        ) : (
          <p className="cr-faint">No guesses</p>
        )}
      </section>
      {missed.length > 0 && (
        <section className="cr-card cr-card-pad results-box">
          <h2 className="cr-section-title">Missed Categories</h2>
          <div className="results-missed">
            {missed.map((g) => (
              <div key={g.level} style={{ background: CAT[g.level] }}>
                <b>{g.name}</b>
                <span>{g.words.join(', ')}</span>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>

    <div className="results-actions">{actions}</div>
  </div>
);

export default GameResults;
